module.exports = __webpack_public_path__ + "static/7377ea480d67db854a0d1695dede341e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/schedule.jpg
// module id = 1195
// module chunks = 0